var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 6,
    fill: "#272D55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6L2 8.2L4 10.4",
    stroke: "#E3ECFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5996 10.3994L13.5996 8.19941L11.5996 5.99941",
    stroke: "#E3ECFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.97852,
    y: 4.80078,
    width: 1.2,
    height: 5.9,
    rx: 0.6,
    transform: "rotate(25.5907 8.97852 4.80078)",
    fill: "#E3ECFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIcon);
export default __webpack_public_path__ + "static/media/codeIcon.e9c7bccd03a6f7559d8baa3bc325cccc.svg";
export { ForwardRef as ReactComponent };